import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TYosyaListGetReq,
  TYosyaInfoGetRes,
  TYosyaUpdatePutReq,
  TYosyaRegisterPostReq,
  TYosyaDeleteReq,
} from "./TYosya"

/**
 * 傭車マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class YosyaService
 * @extends {ConnectApi}
 */
export default class YosyaService extends ConnectApi {
  /**
   * 傭車マスタ 一覧取得
   *
   * @param {TYosyaListGetReq} params
   * @param {(param: TApiResponse<TYosyaGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TYosyaGetListRes>) => any} reject
   * @memberof YosyaService
   */
  getList = async (
    params: TYosyaListGetReq,
    resolve?: (param: TApiResponse<TYosyaInfoGetRes[]>) => any,
    reject?: (param: TApiResponse<TYosyaInfoGetRes[]> | undefined) => any
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TYosyaInfoGetRes[]>> =
        await this.getInner(`/master/yosya`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TYosyaInfoGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TYosyaInfoGetRes>> =
        await this.getInner(`/master/yosya/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TYosyaRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/yosya/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TYosyaUpdatePutReq} data
   * @param {(param: TApiResponse<TYosyaGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TYosyaGetListRes[]>>) => any} reject
   * @memberof YosyaService
   */
  put = async (id: number, data: TYosyaUpdatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/yosya/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TYosyaDeleteReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof YosyaService
   */
  delete = async (id: number, data: TYosyaDeleteReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `master/yosya/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
